export default __webpack_public_path__ + "static/media/video.37c87058.mp4";